<template>
  <div class="nav_wrap">
    <div class="nav_item nav_item_first">
      <div class="nav_item_icon_index" @click="goIndex"></div>
      <div class="nav_item_text" @click="goIndex">远程服务</div>
    </div>
    <div class="nav_item nav_item_arrow" v-if="subNav">
      <div class="nav_item_line"></div>
      <div class="nav_item_text">{{ subNav }}</div>
    </div>
    <div class="nav_item" v-if="false">
      <div class="nav_item_line"></div>
      <div class="nav_item_text">{{ subNav }}</div>
    </div>
    <div class="nav_back" alt="返回" @click="goBack" v-if="isShowBack"></div>
  </div>
</template>

<script>
export default {
  props: ["subNav", "isShowBack"],
  methods: {
    goIndex: function () {
      this.$router.push("/home/node");
    },
    goBack: function () {
      if (this.$listeners.goBack) {
        this.$emit("goBack");
      } else {
        this.$router.back(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nav_wrap {
  height: 40px;
  width: 100%;

  .nav_back {
    display: inline-block;
    vertical-align: top;
    margin-top: 11px;
    margin-left: 10px;
    width: 20px;
    height: 18px;
    background-image: url("../../assets/common/back_btn.svg");
    background-size: 100% 100%;
  }
  .nav_back:hover {
    cursor: pointer;
    opacity: 0.9;
  }
  .nav_item {
    display: inline-block;
    vertical-align: top;
    margin-top: 10px;
    color: #3c3e45;
    font-weight: bolder;
    font-size: 0px;

    .nav_item_icon_index {
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: top;
      background-image: url(../../assets/common/nav/index.svg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 5px;
    }

    .nav_item_line {
      height: 13px;
      width: 2px;
      border-radius: 1px;
      background-color: #c4c4c4;
      vertical-align: top;
      display: inline-block;
      margin-top: 5px;
      margin-right: 12px;
      margin-left: 12px;
    }
    .nav_item_text {
      vertical-align: top;
      display: inline-block;
      font-size: 15px;
      height: 20px;
    }
  }
  .nav_item_first {
    margin-left: 10px;
    cursor: pointer;
    .nav_item_line {
      width: 3px;
      background-color: #1f5de3;
      border-radius: 2px;
      margin-right: 10px;
      margin-left: 0px;
      margin-top: 4px;
      height: 13px;
    }
  }
  .nav_item_first:hover {
    opacity: 0.8;
  }

  .nav_item_arrow {
    .nav_item_line {
      width: 13px;
      height: 13px;
      background-color: transparent;
      background-image: url(../../assets/common/nav_arrow.svg);
      background-size: 100% 100%;
      margin-right: 5px;
      margin-left: 5px;
    }
  }
}
</style>